import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { LanguageHandlerService } from 'src/app/services/language-handler.service';
import { languageConfig } from '../../../constants/language-config';
import { ChangeLangConfig } from 'src/app/models/change-lang-config.model';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { langChangeConsent } from 'src/app/constants/lang-change-consent';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.scss'],
})
export class LanguageSelectionComponent implements OnInit, OnDestroy {
  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
  currentLang = 'Language';
  languageConfig = languageConfig;
  languageConsent = langChangeConsent;
  private langHandlerSubs!: Subscription;
  private langChangeSubs!: Subscription;

  constructor(private translate:TranslateService, private storeService:StoreService, private langHandlerService: LanguageHandlerService, private _snackBar: MatSnackBar) {}

  ngOnInit() {
    this.initCurrentLang();
    this.setLangChangeListener();
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: any) {
    if (this.menuTrigger.menuOpen) {
      this.menuTrigger.closeMenu();
    }
  }
  private initCurrentLang(langCode = this.langHandlerService.currentLang) {
    const {
      langCode: foundLangCode,
      langName,
      translation,
    } = this.languageConfig.find((config) => config.langCode === langCode)!;
    this.formCurrentLang({
      langCode: foundLangCode,
      translation,
      langName,
    });
  }

  private setLangChangeListener() {
    this.langChangeSubs = this.langHandlerService.onLangChange.subscribe(
      ({ lang: langCode }) => {
        this.initCurrentLang(langCode);
      }
    );
  }

  private formCurrentLang({
    langCode,
    translation,
    langName,
  }: ChangeLangConfig) {
    this.currentLang =
      langCode === 'en' ? translation : `${translation} (${langName})`;
  }

  onLangChange({ langCode, translation, langName }: ChangeLangConfig) {
    this._snackBar.open(langCode == 'hi' ? this.languageConsent[1].key:this.languageConsent[0].key, 'Close',{
      duration: 7000,
    });
    this.storeService.langCode.next(langCode);
    this.formCurrentLang({ langCode, translation, langName });
    this.langChangeSubs = this.langHandlerService
    .changeLanguage(langCode)
    .subscribe();
    this.storeService.languageChange.next(true)
  }

  ngOnDestroy() {
    this.langChangeSubs.unsubscribe();
    this.langHandlerSubs?.unsubscribe();
  }
}
